export default __webpack_public_path__ + "static/media/corporate-hr.2e7fff94.png";